// Shipping Popup JavaScript
document.addEventListener('DOMContentLoaded', function() {
  
  // Create popup HTML structure
  const popupHTML = `
    <div class="shipping-popup-overlay" id="shippingPopup">
      <div class="shipping-popup">
        <div class="shipping-popup-header">
          <h2>Versandkosten</h2>
          <button class="shipping-popup-close" aria-label="Schließen">&times;</button>
        </div>
        <div class="shipping-popup-content">
          <div class="shipping-section">
            <h3>Deutschland:</h3>
            <ul>
              <li>Standardversand: <strong>4,99 €</strong></li>
              <li>Versandkostenfrei ab <strong>50 €</strong> Bestellwert</li>
              <li>Lieferzeit: <strong>2-4 Werktage</strong></li>
            </ul>
          </div>
          
          <div class="shipping-section">
            <h3>EU-Ausland:</h3>
            <ul>
              <li>Standardversand: <strong>9,99 €</strong></li>
              <li>Lieferzeit: <strong>5-10 Werktage</strong></li>
            </ul>
          </div>
          
          <div class="shipping-section">
            <h3>Versandpartner:</h3>
            <p>DHL, DPD, UPS, Hermes</p>
          </div>
          
          <div class="shipping-cta">
            <a href="/pages/versand">Weitere Informationen →</a>
          </div>
        </div>
      </div>
    </div>
  `;
  
  // Insert popup into body
  document.body.insertAdjacentHTML('beforeend', popupHTML);
  
  const popup = document.getElementById('shippingPopup');
  const closeBtn = popup.querySelector('.shipping-popup-close');
  
  // Open popup function
  function openPopup() {
    popup.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  
  // Close popup function
  function closePopup() {
    popup.classList.remove('active');
    document.body.style.overflow = '';
  }
  
  // Close button click
  closeBtn.addEventListener('click', closePopup);
  
  // Click outside popup to close
  popup.addEventListener('click', function(e) {
    if (e.target === popup) {
      closePopup();
    }
  });
  
  // ESC key to close
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && popup.classList.contains('active')) {
      closePopup();
    }
  });
  
  // Attach click event to all shipping links
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('shipping-link')) {
      e.preventDefault();
      openPopup();
    }
  });
});
